import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    discountList: [],
    message: null,
    totalRecords: 0,
    discountDetails: {},
    limitationList: [],
    uploadPromotionalCodeLoading: false,
    uploadPromotionalCodeSuccess: null,
    uploadPromotionalCodeError: null,
    promoCodeUsersLoading: false,
    promoCodeUsersSuccess: null,
    promoCodeUsersError: null,
    termGoal:{}
}

export const discountSlice = createSlice({
    name: 'discounts',
    initialState,
    reducers: {
        getDiscountList: (state, action) => {
            state.discountList = action.payload?.data?.data;
            state.totalRecords = action.payload?.data?.totalRecord;
            state.message = action.payload?.message
        },
        getDiscountDetails: (state, action) => {
            state.discountDetails = action.payload
            state.limitationList = action.payload?.limitationList
        },
        resetDiscountForm: (state, action) => {
            state.discountDetails = {}
        },
        setUploadPromotionalCodeLoading: (state) => {
            state.uploadPromotionalCodeLoading = true;
            state.uploadPromotionalCodeSuccess = null;
            state.uploadPromotionalCodeError = '';
        },
        setUploadPromotionalCodeSuccess: (state, action) => {
            state.uploadPromotionalCodeLoading = false;
            state.uploadPromotionalCodeSuccess = action.payload;
            state.uploadPromotionalCodeError = '';
        },
        setUploadPromotionalCodeError: (state, action) => {
            state.uploadPromotionalCodeLoading = false;
            state.uploadPromotionalCodeSuccess = null;
            state.uploadPromotionalCodeError = action.payload;
        },
        setPromoCodeUsersLoading: (state) => {
            state.promoCodeUsersLoading = true;
            state.promoCodeUsersSuccess = null;
            state.promoCodeUsersError = '';
        },
        setPromoCodeUsersSuccess: (state, action) => {
            state.promoCodeUsersLoading = false;
            state.promoCodeUsersSuccess = action.payload;
            state.promoCodeUsersError = '';
        },
        setPromoCodeUsersError: (state, action) => {
            state.promoCodeUsersLoading = false;
            state.promoCodeUsersSuccess = null;
            state.promoCodeUsersError = action.payload;
        },
        resetUploadPromotionalCode: (state, action) => {
            state.uploadPromotionalCodeLoading = false;
            state.uploadPromotionalCodeSuccess = null;
            state.uploadPromotionalCodeError = '';
        },
        setGoal: (state, action) => {
            state.termGoal = action.payload;
          },
    }
})

// Action creators are generated for each case reducer function
export const { setGoal, getDiscountList, getDiscountDetails, resetDiscountForm, setUploadPromotionalCodeLoading, setUploadPromotionalCodeSuccess, setUploadPromotionalCodeError, resetUploadPromotionalCode, setPromoCodeUsersSuccess, setPromoCodeUsersLoading, setPromoCodeUsersError } = discountSlice.actions

export default discountSlice.reducer;